import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SimpleSearch } from '../../../../../reduxToolkit/Search/SearchApi';
import CustomTh from "../../../../../components/table/CustomTh";
import CustomTd from "../../../../../components/table/CustomTd";
import {EMPTY_VALUES, errorMsg, getValueByKey} from "../../../../../Apis/functions";
import TableFunction from "../../../../../components/table/TableFunction";
import { permissionObj } from "../../../../../Helpers/permission";
import { SEARCH_MODEL } from "../../../../../components/table/Model/TableModel";
import { TABLES } from "../../../../../Apis/Tables";
import { DEVICE_TYPE, SIOS_TYPE } from "../../SIOs/Model/Models";
import {CONNECTION_TYPE_MODEL, INPUT_NUMBER_DATA} from "../Model/Models";
import {DeleteItemsApi} from "../../../../../reduxToolkit/Commons/CommonsApi";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Hook that handles the logic for displaying and managing the HID Inputs table.
 * Includes pagination, deletion, search functionality and permission validation.
 */
const MainInputTableApp = ({ selectedList, setSelectedList }) => {
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    // Table configuration and state
    const [tableId, setTableId] = useState("tbl_mit_table");
    const [searchId, setSearchId] = useState("txt_mit_search");
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [search, setSearch] = useState(false);
    const [searchElement, setSearchElement] = useState('');
    const [bodyForExport, setBodyForExport] = useState('');
    const [results, setResults] = useState([]);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [modified, setModified] = useState(false);
    const option = TABLES.HID_INPUT;

    // Permission logic
    const deletePermission = (DEV || permission?.includes(permissionObj?.WEB_HID_DELETE));
    const leftPosition = deletePermission ? 50 : 0;

    /**
     * Builds the table header with translated labels and position settings.
     */
    const getThead = () => {
        return [
            <CustomTh tableId={tableId} classes="first_head" fixedXY={true} left={leftPosition}>{t('name')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('input_number')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('controller')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('sio')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('sio_type')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('device_type')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('connection_type')}</CustomTh>
        ];
    };

    /**
     * Builds the table body rows with formatted data for each input record.
     */
    const getTbody = () => {
        if (!results || results?.content?.length === 0) return { body: [], data: [] };

        const body = results?.content?.map((item) => (
            <>
                <CustomTd tableId={tableId} classes="first-column" fixed={true} left={leftPosition}>
                    {item?.name}
                </CustomTd>
                <CustomTd tableId={tableId}>{getValueByKey(item?.number, 'name', INPUT_NUMBER_DATA)}</CustomTd>
                <CustomTd tableId={tableId}>{item?.hidName}</CustomTd>
                <CustomTd tableId={tableId}>{item?.sioName}</CustomTd>
                <CustomTd tableId={tableId}>{t(getValueByKey(item?.sioType, 'name', SIOS_TYPE))}</CustomTd>
                <CustomTd tableId={tableId}>{getValueByKey(item?.deviceType, 'name', DEVICE_TYPE)}</CustomTd>
                <CustomTd tableId={tableId}>{t(CONNECTION_TYPE_MODEL[item.typeConnection]?.trans) || EMPTY_VALUES.DEFAULT}</CustomTd>
            </>
        ));

        return { body, data: results?.content };
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({ page, size: rowsPerPage, model: option, key:searchElement });
        setBodyForExport(body);
        dispatch(SimpleSearch({ body })).then(
            ({ payload: { data: { data, success } } }) => {
                if (success === true) {
                    setResults(data);
                }
            }
        );
    }
    /**
     * Custom table logic (pagination, checkbox handling, etc.) provided by TableFunction helper.
     */
    const {
        t,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        page,
        rowsPerPage
    } = TableFunction({
        selectedList,
        setSelectedList,
        data: results,
        getThead,
        getTbody,
        labelRowsPerPage: 'inputs_per_page',
        setIsAllChecked,

        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    /**
     * Deletes selected HID inputs if any are selected.
     * Displays success or error notifications accordingly.
     */
    const deleteSelectedInput = () => {
        const body = selectedList;

        if (body.length > 0) {
            dispatch(DeleteItemsApi({ tableName: option, body })).then(
                ({ payload: { data: { success, code } } }) => {
                    if (success === true) {
                        setSelectedList([]);
                        setIsAllChecked(false);
                        setModified(true);
                    }else errorMsg(code);
                }
            );
        }
    };

    return {
        t,
        DEV,
        permission,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        page,
        rowsPerPage,
        setResults,
        option,
        searchElement,
        setSearchElement,
        setSearch,
        setBodyForExport,
        setSimpleSearch,
        deletePermission,
        isAllChecked,
        setModified,
        handleCheckboxChange,
        handleDeleteAll,
        deleteSelectedInput
    };
};

export default MainInputTableApp;
